import { useInfiniteQuery } from '@tanstack/react-query';
import { getTipsFeed, type TipsFeedResponse } from '../api/tipsApi';

export const useTipsFeed = () => {
  return useInfiniteQuery<TipsFeedResponse, Error>({
    queryKey: ['tipsFeed'],
    queryFn: ({ pageParam = 1 }) => getTipsFeed(pageParam as number, 10),
    getNextPageParam: (lastPage) => {
      // Always return next page - loop back to 1 when reaching the end
      if (lastPage.pagination.page < lastPage.pagination.total_pages) {
        return lastPage.pagination.page + 1;
      }
      // Loop back to page 1 for infinite scroll
      return 1;
    },
    initialPageParam: 1,
  });
};
